import React from "react";
import { Typography } from "@stardust-ds/react";

export default function Label(props) {
    const { children, ...rest } = props;

    if (!children) return null;

    return <Typography type="l3" color="#415364" {...rest}>{children}</Typography>
}